import React, { useState } from "react";
import DateTimePicker from "react-datetime-picker";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import { useGetSuppliersQuery } from "../../../features/api/supplierApi";
import { useGetProductQuery } from "../../../features/api/productApi";
import { useGetSubCategoryQuery } from "../../../features/api/subcategoryApi";
import axios from "axios";
import headerLogo from "../../../asset/johura_logo.png";

import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
} from "@react-pdf/renderer";
import { PDFViewer } from "@react-pdf/renderer";
import { API_BASE_URL } from "../../../components/baseUrl";

const styles = StyleSheet.create({
  page: {
    backgroundColor: "white",
    paddingBottom: "88pt",
  },
  header: {
    color: "white",
    marginBottom: 5,
    textAlign: "center",
    height: "3.8cm",
  },
  imgborder: {
    borderBottom: "1px solid green",
    paddingBottom: "5px",
    marginBottom: "3px",
  },
  HedingTextBorder: {
    borderBottom: "1px solid red",
  },

  invMain: {
    textAlign: "center",
    fontSize: "12px",
    paddingBottom: "6px",
  },
  invoice: {
    padding: "10px 20px",
    fontSize: "10px",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  invLeft: {
    fontWeight: "bold",
    flexDirection: "column",
    gap: "4px",
    fontSize: "12px",
  },
  invRight: {
    fontSize: "12px",
  },
  invBottom: {
    fontSize: "11px",
    padding: "0 20 10 20",
    flexDirection: "column",
    gap: "8px",
  },
  footer: {
    color: "white",
    height: "2cm",
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    marginTop: 20,
    textAlign: "center",
    flexDirection: "row",
    justifyContent: "center",
    fontSize: "12",
  },
  footerAddr: {
    height: "",
    color: "black",
    fontSize: "8px",
    margin: "13 auto",
    width: "100%",
    fontWeight: "thin",
  },
  footerBgc: {
    backgroundColor: "#006600",
    height: "0.8cm",
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
  },
  table: {
    borderWidth: 1,
    marginHorizontal: 20,
    borderColor: "#D0D0D0",
    fontSize: "11",
    flexFlow: 1,
  },
  tableHeaderBg: {
    backgroundColor: "#aaa",
  },
  tableRow: {
    flexDirection: "row",
  },
  tableCell: {
    borderBottomWidth: 1,
    borderRight: 1,
    borderColor: "#D0D0D0",
    textAlign: "center",
    padding: 6,
  },
  tableCellTitle: {
    marginBottom: 4,
    fontSize: 12,
    fontWeight: "bold",
    textAlign: "center",
  },
  author: {
    fontSize: "10px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: "50px",
    padding: "0 20px",
  },
  authorText: {
    borderTop: "1px solid black",
    paddingTop: "1px",
  },
  pageNumber: {
    position: "absolute",
    bottom: 55,
    right: 20,
    fontSize: 10,
  },
});

const TransactionReport = () => {
  const [visible, setVisible] = useState(true);

  const suppliers = useGetSuppliersQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.supplier;

  const products = useGetProductQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.data;

  const subCategories = useGetSubCategoryQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.subcategories;

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  let getSDay = startDate.getDate();
  let getSMonth = startDate.getMonth() + 1;
  let getSYear = startDate.getFullYear();
  let getStartDate = getSYear + "-" + getSMonth + "-" + getSDay;

  let getEDay = endDate.getDate();
  let getEMonth = endDate.getMonth() + 1;
  let getEYear = endDate.getFullYear();
  let getEndDate = getEYear + "-" + getEMonth + "-" + getEDay;

  const [purchases, setPurchases] = useState([]);
  const [salesData, setSalesData] = useState([]);
  const [expenseData, setExpenseData] = useState([]);

  const combinedData = [];

  combinedData.push(
    ...purchases?.map((purchase, index) => ({
      serial: index + 1,
      orderId: purchase.ch_no,
      date: purchase.ch_date,
      product: purchase.pro_name,
      purchase: purchase.total,
      sales: 0,
      expenses: 0,
    }))
  );

  combinedData.push(
    ...salesData?.map((order, index) => ({
      serial: index + 1,
      orderId: order.inv_no,
      date: order.inv_date,
      product: order.pro_name,
      purchase: 0,
      sales: order.total,
      expenses: 0,
    }))
  );

  combinedData.push(
    ...expenseData?.map((expense, index) => ({
      serial: index + 1,
      orderId: expense.exp_no,
      date: expense.exp_date,
      particular: expense.item,
      purchase: 0,
      sales: 0,
      expenses: expense.total,
    }))
  );

  const purchaseTotal = purchases?.reduce(
    (total, purchase) => total + purchase.total,
    0
  );
  const salesTotal = salesData?.reduce(
    (total, order) => total + order.total,
    0
  );
  const expensesTotal = expenseData?.reduce(
    (total, expense) => total + expense.total,
    0
  );

  const sDate = new Date(startDate);
  let sDay = sDate.getDate();
  let sMonth = sDate.getMonth() + 1;
  let sYear = sDate.getFullYear();
  let sGetDate = sDay + "-" + sMonth + "-" + sYear;

  const eDate = new Date(endDate);
  let eDay = eDate.getDate();
  let eMonth = eDate.getMonth() + 1;
  let eYear = eDate.getFullYear();
  let eGetDate = eDay + "-" + eMonth + "-" + eYear;

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/purchaseDate?startDate=${getStartDate}&endDate=${getEndDate}`
      );
      const response2 = await axios.get(
        `${API_BASE_URL}/api/expenseDate?startDate=${getStartDate}&endDate=${getEndDate}`
      );

      const response3 = await axios.get(
        `${API_BASE_URL}/api/ordersDate?startDate=${getStartDate}&endDate=${getEndDate}`
      );

      if (response && response2 && response3) {
        setPurchases(response?.data?.purchases);
        setExpenseData(response2?.data?.Expenses);
        setSalesData(response3?.data?.sales);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const grandTotal = purchases?.reduce((sum, data) => sum + data?.total, 0);
  const totalQuantity = purchases?.reduce((sum, data) => sum + data?.qty, 0);

  // function for formated date
  function formatDate(dateString) {
    const date = new Date(dateString);
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let getDate = day + "-" + month + "-" + year;
    return getDate;
  }

  const user = JSON.parse(localStorage.getItem("user"));
  return (
    <div className="px-6 overflow-auto">
      <div>
        <h1 className="font-bold text-xl my-4">Transaction Reports</h1>
        <div className="bg-white shadow p-4 flex items-center justify-between">
          <form onSubmit={handleSubmit} className="flex items-center gap-10">
            <div>
              <label className="font-bold">Start Date: </label>
              <DateTimePicker
                value={startDate}
                onChange={setStartDate}
                className="border w-full pl-1 mt-1"
              />
            </div>
            <div>
              <label className="font-bold">End Date: </label>
              <DateTimePicker
                value={endDate}
                onChange={setEndDate}
                className="border w-full pl-1 mt-1"
              />
            </div>
            <input
              type="submit"
              value="View"
              className="bg-indigo-500 text-white font-bold px-2 rounded mt-6 py-1 cursor-pointer"
            />
          </form>
        </div>
      </div>
      {combinedData?.length > 0 && (
        <div>
          <input
            onClick={() => setVisible(!visible)}
            type="checkbox"
            defaultChecked
            className="cursor-pointer"
          />
          <PDFViewer style={{ width: "100%", height: "100vh" }}>
            <Document>
              <Page size="A4" style={styles.page}>
                {/* Header */}
                <View style={styles.header} fixed>
                  {visible && (
                    <View>
                      <View style={styles.imgborder}>
                        <Image src={headerLogo} />
                      </View>
                      <Text style={styles.HedingTextBorder}></Text>
                    </View>
                  )}
                </View>

                {/* Invoice */}
                <View style={styles.invMain}>
                  <Text>
                    Transaction Report - Date: {sGetDate} to {eGetDate}
                  </Text>
                </View>

                {/* Table */}
                <View style={styles.table}>
                  {/* Table Header */}
                  <View
                    style={{ ...styles.tableRow, ...styles.tableHeaderBg }}
                    fixed
                  >
                    <View style={{ ...styles.tableCell, width: "8%" }}>
                      <Text>Sl No.</Text>
                    </View>
                    <View style={{ ...styles.tableCell, width: "11%" }}>
                      <Text>Invoice</Text>
                    </View>
                    <View style={{ ...styles.tableCell, width: "15%" }}>
                      <Text>Date</Text>
                    </View>
                    <View style={{ ...styles.tableCell, width: "30%" }}>
                      <Text>Product</Text>
                    </View>
                    <View style={{ ...styles.tableCell, width: "12%" }}>
                      <Text>Purchase</Text>
                    </View>
                    <View style={{ ...styles.tableCell, width: "12%" }}>
                      <Text>Sales</Text>
                    </View>
                    <View
                      style={{
                        ...styles.tableCell,
                        width: "12%",
                        borderRight: 0,
                      }}
                    >
                      <Text>Expenses</Text>
                    </View>
                  </View>

                  {/* Table Data */}
                  {combinedData?.map((data, index) => {
                    const suppName = suppliers?.find(
                      (supp) => supp?.id === data?.supp_name
                    );
                    const proName = products?.find(
                      (pro) => pro?.id === data?.product
                    );
                    const itemName = subCategories?.find(
                      (pro) => pro?.id === data?.particular
                    );

                    return (
                      <View key={index} style={styles.tableRow}>
                        <View style={{ ...styles.tableCell, width: "8%" }}>
                          <Text>{index + 1}</Text>
                        </View>
                        <View
                          style={{
                            ...styles.tableCell,
                            width: "11%",
                            textAlign: "left",
                          }}
                        >
                          <Text>{data?.orderId}</Text>
                        </View>
                        <View
                          style={{
                            ...styles.tableCell,
                            width: "15%",
                            textAlign: "left",
                          }}
                        >
                          <Text>{formatDate(data?.date)}</Text>
                        </View>
                        <View
                          style={{
                            ...styles.tableCell,
                            width: "30%",
                            textAlign: "left",
                          }}
                        >
                          <Text>
                            {proName?.product_name || itemName?.sub_catName}
                          </Text>
                        </View>
                        <View
                          style={{
                            ...styles.tableCell,
                            width: "12%",
                            textAlign: "center",
                          }}
                        >
                          <Text>{data?.purchase}</Text>
                        </View>
                        <View style={{ ...styles.tableCell, width: "12%" }}>
                          <Text> {data?.sales}</Text>
                        </View>
                        <View
                          style={{
                            ...styles.tableCell,
                            width: "12%",
                            borderRight: 0,
                          }}
                        >
                          <Text>{data?.expenses}</Text>
                        </View>
                      </View>
                    );
                  })}
                  <View style={styles.tableRow}>
                    <View
                      style={{
                        ...styles.tableCell,
                        borderBottom: 0,
                        width: "64% ",
                        textAlign: "right",
                      }}
                    >
                      <Text style={{ fontSize: "12px" }}>Total:</Text>
                    </View>
                    <View
                      style={{
                        ...styles.tableCell,
                        borderBottom: 0,
                        width: "12% ",
                        textAlign: "center",
                      }}
                    >
                      <Text style={{ fontSize: "12px" }}>{purchaseTotal}</Text>
                    </View>
                    <View
                      style={{
                        ...styles.tableCell,
                        borderBottom: 0,
                        width: "12% ",
                        textAlign: "center",
                      }}
                    >
                      <Text style={{ fontSize: "12px" }}>{salesTotal}</Text>
                    </View>
                    <View
                      style={{
                        ...styles.tableCell,
                        borderBottom: 0,
                        borderRight: 0,
                        width: "12% ",
                        textAlign: "center",
                      }}
                    >
                      <Text style={{ fontSize: "12px" }}>{expensesTotal}</Text>
                    </View>
                  </View>
                </View>

                <View style={styles.author} fixed>
                  <Text style={styles.authorText}>Received By:</Text>
                  <Text>Prepared By: {user?.name}</Text>
                  <Text style={styles.authorText}>Authorised Signature</Text>
                </View>

                {/* Page Number */}
                <View style={styles.pageNumber} fixed>
                  <Text
                    render={({ pageNumber, totalPages }) =>
                      `page ${pageNumber} of ${totalPages}`
                    }
                  />
                </View>

                {/* Footer */}
                <View style={styles.footer} fixed>
                  {visible && (
                    <View style={styles.footerAddr}>
                      <Text>
                        15/A Zigatola, Hafizullah Green Tower, Flat # C1,
                        Dhanmondi, Dhaka - 1209
                      </Text>
                      <Text>
                        Cell: 01711-071102, 01977-071102, 01778-874364, E-mail:
                        jahangirjohura@gmail.com / Web: www.johurabd.com
                      </Text>
                    </View>
                  )}
                  {visible && <Text style={styles.footerBgc}></Text>}
                </View>
              </Page>
            </Document>
          </PDFViewer>
        </div>
      )}
    </div>
  );
};

export default TransactionReport;
